import React from 'react';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy-container">
      <h1>MOMOH Mobile Privacy Policy</h1>
      <p className="last-updated">Last Updated: December 17, 2024</p>

      <div className="privacy-policy-content">
        <section>
          <h2>1. Introduction</h2>
          <p>MOMOH Mobile ("we," "our," or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, and safeguard your information when you use our mobile application (the "App").</p>
        </section>

        <section>
          <h2>2. Information We Collect</h2>
          <h3>2.1 Information You Provide:</h3>
          <ul>
            <li>Account information (email address, name)</li>
            <li>Restaurant and location data</li>
            <li>Form submissions and responses</li>
            <li>User preferences and settings</li>
          </ul>

          <h3>2.2 Automatically Collected Information:</h3>
          <ul>
            <li>Device information (model, operating system)</li>
            <li>App usage statistics</li>
            <li>Login timestamps</li>
            <li>Error logs</li>
          </ul>
        </section>

        <section>
          <h2>3. How We Use Your Information</h2>
          <p>We use the collected information to:</p>
          <ul>
            <li>Provide and maintain the App's functionality</li>
            <li>Process and manage form submissions</li>
            <li>Improve user experience</li>
            <li>Send important notifications</li>
            <li>Monitor app performance</li>
            <li>Ensure security and prevent fraud</li>
          </ul>
        </section>

        <section>
          <h2>4. Data Storage and Security</h2>
          <p>Your data is stored securely in Google Firebase. We implement industry-standard security measures to protect your information, including:</p>
          <ul>
            <li>Secure data encryption</li>
            <li>Regular security audits</li>
            <li>Access controls and authentication</li>
            <li>Secure data transmission</li>
          </ul>
        </section>

        <section>
          <h2>5. Data Sharing and Third Parties</h2>
          <p>We do not sell your personal information. We may share your data with:</p>
          <ul>
            <li>Firebase (for authentication and data storage)</li>
            <li>Analytics providers (to improve app performance)</li>
            <li>Your restaurant organization (for operational purposes)</li>
          </ul>
        </section>

        <section>
          <h2>6. Your Rights</h2>
          <p>You have the right to:</p>
          <ul>
            <li>Access your personal information</li>
            <li>Request corrections to your data</li>
            <li>Request deletion of your data</li>
            <li>Opt-out of certain data collection</li>
            <li>Export your data</li>
          </ul>
        </section>

        <section>
          <h2>7. Contact Us</h2>
          <p>If you have any questions about this Privacy Policy or our data practices, please contact us at:</p>
          <p>Email: support@momoh.io</p>
        </section>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
